import { AddMargins } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import { GroupMatrix, PlotFunction } from "@pdfking/renderer-api"
import { NullQ } from "@pdfking/structs"
import { GrowContentKind } from "@pdfking/templates"

import { PALETTE } from "#constants"
import type { DrawPage } from "#internal"

import { DrawBackpackGrid } from "../pattern/DrawBackpackGrid"
import { CreateRandom } from "../random/CreateRandom"
import { BookContentOf } from "./BookContent"
import type { Composition } from "./Composition"
import { ComposePieces, Ground } from "./Composition"

/** A calendar made of its pieces, its pages by `draw_page`: its cover's too,
 * a Copertina's or a desk calendar's Basetta, on paper over the ground, its
 * spine and flaps the calendar's pattern, no book's title; any other grow as
 * a book's pages. */
export const CalendarContentOf =
  (draw_page: DrawPage) =>
  (c: Composition): PageShape[] => {
    if (!c.is_cover) return BookContentOf(draw_page, false)(c)
    const { is_front, seed, short } = c
    const pattern = (
      box: Parameters<typeof DrawBackpackGrid>[0]["box"],
      i: number,
      bleed = c.bleed
    ) =>
      is_front
        ? DrawBackpackGrid({ bleed, box, random: CreateRandom(seed, "cover", i), short })
        : []
    return [
      ...Ground(c),
      ...ComposePieces(c, {
        [GrowContentKind.FLAP]: ({ box, index, reach }) => pattern(box, index, reach),
        [GrowContentKind.PAGE]: ({ box, number, reach, security }) => {
          if (NullQ(number))
            return [{ enum: PlotFunction.PLOT_RECT, fill_color: PALETTE.paper, position: box }]
          return [
            {
              enum: PlotFunction.PLOT_RECT,
              fill_color: PALETTE.paper,
              position: AddMargins(box, reach),
            },
            {
              enum: PlotFunction.PLOT_GROUP,
              matrix: GroupMatrix({ translate: { x: box.x, y: box.y } }),
              shapes: draw_page({ ...c, bleed: reach, page_number: number, security, size: box }),
            },
          ]
        },
        [GrowContentKind.SPINE]: ({ box, index, reach }) => pattern(box, index, reach),
      }),
    ]
  }
